import React from 'react';
import { Button } from 'primereact/button';

export interface EmptyFeedbackStateProps {
  onAddFeedback: () => void;
}

export const EmptyFeedbackState: React.FC<EmptyFeedbackStateProps> = ({
  onAddFeedback,
}) => {
  return (
    <div
      style={{
        textAlign: 'center',
        padding: '48px 24px',
        backgroundColor: '#f9fafb',
        borderRadius: '12px',
        border: '1px dashed #d1d5db',
      }}
    >
      <i
        className="pi pi-comments"
        style={{
          fontSize: '3rem',
          color: '#9ca3af',
          marginBottom: '16px',
          display: 'block',
        }}
      />
      <p
        style={{
          color: '#6b7280',
          fontSize: '16px',
          margin: '0 0 16px 0',
        }}
      >
        אין משובי הוראה בקורס זה
      </p>
      <Button
        label="הוסף משוב ראשון"
        icon="pi pi-plus"
        className="p-button-outlined"
        onClick={onAddFeedback}
      />
    </div>
  );
};
